import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  LinearProgress,
  Grid,
  useTheme,
  alpha
} from '@mui/material';

const QuickStatsCard = ({ stats = [] }) => {
  const theme = useTheme();

  const defaultStats = [
    { label: 'Portfolio Value', value: 75, color: 'primary' },
    { label: 'ROI Performance', value: 82, color: 'success' },
    { label: 'Market Analysis', value: 65, color: 'info' },
    { label: 'Risk Assessment', value: 45, color: 'warning' },
  ];

  const statsList = stats.length > 0 ? stats : defaultStats;

  const getColor = (colorName) => {
    switch (colorName) {
      case 'primary': return theme.palette.primary.main;
      case 'secondary': return theme.palette.secondary.main;
      case 'success': return theme.palette.success.main;
      case 'error': return theme.palette.error.main;
      case 'warning': return theme.palette.warning.main;
      case 'info': return theme.palette.info.main;
      default: return theme.palette.primary.main;
    }
  };

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h6" fontWeight="600">
            Quick Stats
          </Typography>
        }
        subheader="Performance indicators at a glance"
      />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={3}>
          {statsList.map((stat, index) => (
            <Grid item xs={12} key={index}>
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2" fontWeight="500" color="text.secondary">
                    {stat.label}
                  </Typography>
                  <Typography variant="body2" fontWeight="600" color={`${stat.color}.main`}>
                    {stat.value}%
                  </Typography>
                </Box>
                <LinearProgress
                  variant="determinate"
                  value={stat.value}
                  sx={{
                    height: 8,
                    borderRadius: 4,
                    bgcolor: alpha(getColor(stat.color), 0.1),
                    '& .MuiLinearProgress-bar': {
                      borderRadius: 4,
                      bgcolor: getColor(stat.color),
                    }
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuickStatsCard;











